'use client';
/**
 * LandingAnalytics — Client Component que emite `Landing Page Viewed` no after-mount.
 *
 * Injetado em todas as 5 rotas públicas como filho do Server Component.
 * Recebe as props base via Server Component (não faz fetch client-side).
 * Segue o padrão de legal-documents-v1 (`LegalDocumentAnalytics`).
 */
import * as React from 'react';
import {
  trackLandingPageViewed,
  type BaseLandingEventProps,
  type LandingRoute,
} from '@brisa/shared/observability/landing';

interface LandingAnalyticsProps extends BaseLandingEventProps {
  path: string;
  route: LandingRoute;
  locale: 'pt' | 'es';
}

export function LandingAnalytics({ path, route, locale, ...base }: LandingAnalyticsProps) {
  React.useEffect(() => {
    const referrer = document.referrer || null;
    const searchParams = new URLSearchParams(window.location.search);
    trackLandingPageViewed(
      {
        path,
        route,
        locale,
        referrer,
        utm_source: searchParams.get('utm_source') ?? undefined,
        utm_medium: searchParams.get('utm_medium') ?? undefined,
        utm_campaign: searchParams.get('utm_campaign') ?? undefined,
      },
      base,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
